/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/critical-variables.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

const propArray = ['Active', 'CriticalToQualityFactorId', 'LibraryReferenceId', 'ResponsibleFunctionId', 'StudyId'];

const FunctionalDataRviewsRecordChangeGrid = ({ newItem, oldItem, oldRecord, newRecord }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
        CriticalToQualityFactor:
            oldRecord?.criticalToQualityFactor != null ? oldRecord?.criticalToQualityFactor?.description : null,
        ResponsibleFunction: oldRecord?.responsibleFunction != null ? oldRecord?.responsibleFunction?.name : null,
    };

    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              ...removePropertiesFromObject(newRecord, propArray),
              CriticalToQualityFactor: !oldItem
                  ? newItem?.criticalToQualityFactor != null
                      ? newItem?.criticalToQualityFactor?.description
                      : null
                  : newRecord?.criticalToQualityFactor != null
                    ? newRecord?.criticalToQualityFactor?.description
                    : null,
              ResponsibleFunction: !oldItem
                  ? newItem?.responsibleFunction != null
                      ? newItem?.responsibleFunction?.name
                      : null
                  : newRecord?.responsibleFunction != null
                    ? newRecord?.responsibleFunction?.name
                    : null,
          }
        : newRecord;

    const enums: any = {};
    const associations: any = {};

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            associations,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { FunctionalDataRviewsRecordChangeGrid };
